import { ADD_STEP, EMPTY_STEP, REMOVE_STEP, UPDATE_STEP } from "../../constants/actionTypes";

const initialState = { steps: [], loading: false, error: null };

const education = (state = initialState, action) => {
    switch (action.type) {
        case ADD_STEP:
            return { ...state, steps: [...state.steps, ...action.payload] };
        case UPDATE_STEP:
            const steps = [...state.steps];
            const stepIndex = steps.findIndex(step => step.id === action.payload.id);
            steps[stepIndex] = { ...action.payload };
            return { ...state, steps: [...steps] };
        case REMOVE_STEP:
            return { ...state, steps: state.steps.filter(step => step.id !== action.payload) };
        case EMPTY_STEP:
            return { ...state, steps: [] };
        default:
            return state;
    }
};

export default education;
